module.exports = __webpack_public_path__ + "static/2015-layer-1-f051ae766ec8944377e453646ec1ffb7.png";